import { Component, inject } from '@angular/core';
import { ActivatedRoute, RouterLink, RouterLinkActive } from '@angular/router';
import { COMMON_IMPORTS, PIPES_IMPORTS } from '../../imports/common-imports';
import { RISK_FLAGS } from '../../data/risk-flags';

@Component({
  selector: 'app-breadcrumb',
  standalone: true,
  imports: [COMMON_IMPORTS, RouterLink, RouterLinkActive, PIPES_IMPORTS],
  templateUrl: './breadcrumb.component.html',
  styleUrl: './breadcrumb.component.scss',
})
export class BreadcrumbComponent {
  private route = inject(ActivatedRoute);
  therapeuticArea = '';
  elementName = '';
  activeFlag = '';
  flagName = '';
  compare = false;
  ngOnInit() {
    this.route.paramMap.subscribe((params) => {
      this.therapeuticArea = params.get('ta') ?? '';
      this.elementName = params.get('element') ?? '';
      this.activeFlag = params.get('flag') ?? '';

      this.compare = !!params.get('type');

      if (this.activeFlag) {
        const flagData = this.activeFlag.split('_');
        const flag = flagData[0];
        const riskActivity = flagData[1];

        this.flagName =
          flag + ' - ' + RISK_FLAGS.find((f) => f.link === riskActivity)?.name;
      }
    });
  }
}
